import React from 'react';
import { connect } from 'react-redux';
import { RouteProps, withRouter, RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PageView } from '@jg/react-tracking';
import { getJoinRoutes, JoinRoutes } from '../../selectors/routeSelectors';
import { appThunk } from '../../actions';

import { IAppState } from '../../types/state.d';
import config from '../../config';

type UnableToJoinProps = RouteComponentProps<unknown> & {
  joinRoutes: JoinRoutes;
  pushToPage: typeof appThunk.pushToPage;
};

export const UnableToJoin = ({ joinRoutes, pushToPage }: UnableToJoinProps) => {
  const { t } = useTranslation();

  return (
    <PageView
      trackingData={{
        subtype: 'join team',
        event_value: 'unable to connect existing FRP',
        page_section: 'join team > unable to join',
      }}
    >
      <main data-qa="unable-to-join-page">
        <div className="row">
          <div className="col-md-8 offset-md-2 jg-text--center">
            <img
              className="jg-space-mvmd"
              src={`${config.publicPath}public/robot-are-you-sure.svg`}
              alt="JustGiving robot"
              width="130"
              height="123"
            />
            <h1 className="jg-space-mbmd">
              {t('content.unableToJoin.heading')}
            </h1>
            <p className="jg-text--large">
              {t('content.unableToJoin.paragraphOne')}
            </p>
            <p className="jg-text--large">
              {t('content.unableToJoin.paragraphTwo')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <button
              type="button"
              className="jg-btn jg-button-brand jg-space-mvml"
              onClick={() =>
                joinRoutes.nextStep && pushToPage(joinRoutes.nextStep)
              }
            >
              {t('content.join.button.createfundraisingpage')}
            </button>
          </div>
        </div>
      </main>
    </PageView>
  );
};

const mapStateToProps = (state: IAppState, ownProps: RouteProps) => ({
  joinRoutes: getJoinRoutes(state, ownProps),
});

const mapDispatchToProps = {
  pushToPage: appThunk.pushToPage,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(UnableToJoin),
);
